/** 
 * The two windows are the same object only when nothing is above us. 
 */
export function isInHostFrame() {
    return window.self !== window.top;
}

/**
 * The URL to open the tour at when the frame is too small to open it in.
 */
export function ownPageUrl() {
    return window.location.href;
}
